/** Shared low-balance → buy/pay link helpers. The server fields win when present. */

export function isLowBalanceMeter(meter, alerts = []) {
  if (!meter) return false;
  const balance = meter.projected_balance_units ?? meter.balance_units;
  const meterNumber = meter.meter_number || meter.account_number;
  const breached = (alerts || []).some((alert) => {
    if (alert.alert_type !== "low_balance") return false;
    if (alert.meter_number && meterNumber && alert.meter_number !== meterNumber) return false;
    return balance != null && Number(balance) < Number(alert.threshold);
  });
  if (breached) return true;
  if (balance != null && Number(balance) < 50) return true;
  if (meter.meter_mode === "postpaid" || meter.buy_label === "Pay bill") return false;
  const days = meter.projected_days_remaining;
  return days != null && Number(days) < 7;
}

export function buyPath(meter) {
  if (!meter) return "/buy";
  if (meter.buy_url) return meter.buy_url;
  const params = new URLSearchParams();
  const meterNumber = meter.meter_number || meter.account_number || "";
  if (meterNumber) params.set("meter", meterNumber);
  if (meter.provider_code) params.set("provider", meter.provider_code);
  const postpaid = meter.meter_mode === "postpaid" || meter.buy_label === "Pay bill";
  if (!postpaid && meter.suggested_amount) params.set("amount", String(meter.suggested_amount));
  const query = params.toString();
  return query ? `/buy?${query}` : "/buy";
}

export function buyLabel(meter) {
  if (meter?.buy_label) return meter.buy_label;
  if (meter?.meter_mode === "postpaid") return "Pay bill";
  return "Buy units";
}
